// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CLIENTES_CLEAR_CLIENTE,
} from './constants';

export function clearCliente() {
  return {
    type: CLIENTES_CLEAR_CLIENTE,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CLIENTES_CLEAR_CLIENTE:
      return {
        ...state,
        selectedClient: null,
        getClienteError: null,
        getClientePending: false,
        updateClienteSuccess: false,
        updateClienteError: null,
        updatedClienteId: null,
      };

    default:
      return state;
  }
}
